export const allowedExtensions = [
  "doc",
  "docx",
  "pdf",
  "png",
  "jpg",
  "jpeg",
  "gif",
  "txt",
  "ppt",
  "pptx",
  "mp3",
  "wav",
  "aac",
  "ogg",
  "aiff",
  "wma",
  "csv",
  "xlsx",
  "xls",
];

export const allowedExtensionsCover = ["pdf"];

export const allowedExtensionsKnowledge = [
  "doc",
  "docx",
  "pdf",
  "txt",
  "ppt",
  "pptx",
];

export const allowedExtensionsAnnex = ["pdf", "png", "jpg", "jpeg"];

export const MAX_FILE_SIZE = 40 * 1024 * 1024;
